module.exports = __webpack_public_path__ + "img/img11.02274b69.png";